module.exports = __webpack_public_path__ + "static/media/4. Effendy.33e80115.png";